<template>
	<v-container fluid>
		<div v-if="isLoaded">
			<v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
			<!--table head-->
			<v-divider color="black" />
			<div v-if="market_segments?.length > 0">
				<v-row class="subtitle-2 my-1" no-gutters>
					<v-col cols="2" class="text-left">{{'Products' | localize}}</v-col>
					<v-divider vertical color="black" />
					<v-col v-for="seg in market_segments" 
						:key="seg.id"
						class="text-right pr-1">
						{{ seg.segment.name }}
					</v-col>
					<v-divider vertical />
					<v-col class="text-right pr-1 font-weight-bold">{{'Total (year)' | localize}}</v-col>
				</v-row>
				<v-divider color="black" />
				<!--table content-->
				<div v-if="sales?.length > 0">
					<div v-for="product in sales" :key="product.id">
						<v-row class="body-2 my-1" no-gutters>
							<v-col cols="2" class="text-left">{{product.trademark.name}} - {{ product.model }}</v-col>
							<v-divider vertical />
							<v-col v-for="seg in market_segments" 
								:key="seg.id"
								class="text-right pr-1">
								{{ formatNumber(segmentSale(product, seg)) }}
							</v-col>
							<v-divider vertical />
							<v-col class="text-right pr-1 font-weight-bold">{{ formatNumber(product.sales_units) }}</v-col>
						</v-row>
						<v-divider />
					</div>
				</div>
			</div>
		</div>
		<v-row v-else justify="center" class="mt-12">
			<loader />
		</v-row>	
	</v-container>
</template>
<script>
	import Loader from '../../../layouts/Loader.vue'
	import { localeNumber } from '../../../functions/common'
	import Information from '../../../layouts/Information.vue';

	export default {
		data () {
			return {
				panel: [0],
				isLoaded: false,
				text: {
					en: 'The company’s product sales are broken down by market segment to assess the relative importance of each segment to the overall business performance.',
					ro: 'Vânzările de produse ale companiei sunt defalcate pe segmente de piață pentru a evalua importanța relativă a fiecărui segment în raport cu performanța generală a afacerii.',
					ru: 'Продажи продукции компании разбиты по сегментам рынка с целью оценки относительной значимости каждого сегмента для общей эффективности бизнеса.'
				},
			}
		},
		computed: {
			locale() {
				return this.$store.getters.locale;
			},
			team() {
				return this.$store.getters.team;
			},
			game() {
				return this.$store.getters.game;
			},
			monthSales() {
				return this.$store.getters.monthSales_team;
			},
			sales() {
				return this.$store.getters.sales_team;
			},
			market_segments() {
				return this.$store.getters.market_segments;
			},
		},
		methods: {
			formatNumber(num) {
				let res = 0
				if (num) {
					res = localeNumber(num, this.locale);
				}
				return res;
			},
			segmentSale(product, segment) {
				let res = 0
				if (this.monthSales?.length > 0) {
					const sales = this.monthSales.filter((it) => it.productId == product.productId && it.segmentId == segment.segmentId);
					if (sales.length > 0) {
						res = sales.reduce((sum, item) => {
							return sum+= item.sales_normalized;
						}, 0)
					}
				}
				return res;
			}
		},
		components: {
			Loader, Information
		},
		async created() {

			if ( this.game && this.team) {

				const params = {
					gameId: this.game.id,
					round: this.game.round > 0 ? this.game.round - 1 : 0,
					teamId: this.team.id,
				}

				if (this.monthSales?.length < 1) {
					try {
						//get last round sales 
						await this.$store.dispatch('fetchTeamMonthsales', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}
				if (this.market_segments?.length < 1) {
					try {
						await this.$store.dispatch('fetchMarketSegments', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}

				/* get last round team sales */
				if (this.sales == null) {
				
					try {
						await this.$store.dispatch('fetchTeamSales', params);
					} catch (error) {
						await this.$store.dispatch('setError', error.message);
					}
				}
			}

			this.isLoaded = true;
			
		}
	}
</script>